// src/App.js
import React, { useEffect } from "react";
import { Routing } from "./routes/Routing";
import ReactGA from "react-ga";
import { Toaster } from "react-hot-toast";
import "./App.css";
import { ToastProvider } from "./ToastContext";
import { FormProvider } from "./components/FormContext";
import { NavigationProvider } from "./components/NavigationContext";
import { UserFormProvider } from "./components/UserFormContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

const App = () => {

  useEffect(() => {
    ReactGA.initialize("G-D3YYY1TKVY");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <UserFormProvider>
        <NavigationProvider>
          <ToastProvider>
            <FormProvider>
              <div>
                <Routing />
                <Toaster />
              </div>
            </FormProvider>
          </ToastProvider>
        </NavigationProvider>
      </UserFormProvider >
    </GoogleOAuthProvider>
  );
};

export default App;
